/**
 * Class Configuration
 * 
 * Configuration constants for the classes page including pagination,
 * expert categories, and filter options.
 */

export interface ClassCategory {
  id: string;
  name: string;
  apiFilter: string;
}

// Pagination
export const CLASSES_PER_PAGE = 12;

// Expert Categories for Classes Page
export const CLASS_EXPERT_CATEGORIES: ClassCategory[] = [
  { id: "all", name: "All Classes", apiFilter: "all" },
  { id: "yoga", name: "Yoga", apiFilter: "yogaInstructor" },
  { id: "pranayama", name: "Pranayama", apiFilter: "pranayamaCoach" },
  { id: "meditation", name: "Meditation", apiFilter: "meditationCoach" },
  { id: "zumba", name: "Zumba", apiFilter: "zumbaInstructor" },
  { id: "nutrition", name: "Nutrition", apiFilter: "nutritionist" },
  { id: "ayurveda", name: "Ayurveda", apiFilter: "ayurvedaPractitioner" },
  { id: "women-wellness", name: "Women's Wellness", apiFilter: "womenWellnessCoach" },
  { id: "self-defense", name: "Self Defense", apiFilter: "selfDefenseInstructor" },
];
